// extracted by mini-css-extract-plugin
module.exports = {"main-component":"objectives_main-component__3A3oL"};